import React from 'react';
import { includes, isEmpty } from 'lodash';
import Slider from 'react-slick';
import CountUp from 'react-countup';
import ReactVisibilitySensor from 'react-visibility-sensor';
import { Link } from './styles/Link.styled';
import { Container } from './styles/Container.styled';
import { Row } from './styles/Row.styled';
import { StatInfo, StatCaption } from './styles/StatInfo.styled';
import { DWTCContext } from '../utils/context';
import Sprites from './Sprites';

export default function IntroWithStats({ data, dir, id }) {
  const { cssClass } = React.useContext(DWTCContext);

  const getTheme = () => {
    if (includes(cssClass, 'free-zone')) return 'red';
    if (includes(cssClass, 'real-estate')) return 'green';
    return 'secondary';
  };
  const directionSlider = dir === 'ltr' ? '' : 'true';

  const settings = {
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
    autoplay: false,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          slidesToShow: 1,
          infinite: true,
          autoplay: false,
          dots: true,
          rtl: directionSlider,
        },
      },
    ],
  };

  const [toggleState, setToggleState] = React.useState(false);

  const handleVisibilityChange = (isVisible) => {
    if (isVisible) setToggleState(true);
  };

  return (
    <StatInfo color={getTheme()} id="introWithStats">
      <Container id={id}>
        <StatCaption className="intro_stat" dir={dir}>
          {isEmpty(data.backLink) || (
            <p className="stat-link-wrapper" dir={dir}>
              <Link className="home_link view_all" to={data.backLink.url} dir={dir}>
                <Sprites name="arrow" className="arrow" /> <span>{data.backLink.name}</span>
              </Link>
            </p>
          )}
          <h2 dir={dir}>{data.title}</h2>
        </StatCaption>
        <Row>
          <ul className="figures" dir={dir}>
            <Slider {...settings}>
              {data.statistics.map(({ content: { title, value } }) => (
                <div className="list-container">
                  <p className="num" dir={dir}>
                    <CountUp start={toggleState ? 0 : value} end={+value} delay={0}>
                      {({ countUpRef }) => (
                        <ReactVisibilitySensor onChange={handleVisibilityChange} delayedCall>
                          <span ref={countUpRef} />
                        </ReactVisibilitySensor>
                      )}
                    </CountUp>
                  </p>
                  <p className="numtxt" dir={dir}>
                    {title}{' '}
                  </p>
                </div>
              ))}
            </Slider>
          </ul>
        </Row>
      </Container>
    </StatInfo>
  );
}
